import { Button, Col } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Span = styled.span`
  text-decoration: underline;
`;

export const UserButton = styled(Button)`
  width: 25px !important;
  height: 25px !important;
`;

export const UserDeleteButton = styled(Button)`
  min-width: 25px !important;
  width: 25px !important;
  height: 25px !important;
`;

export const ActionBtnWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
